import React from "react";
import { UserInterface, useServiceStore, useUserService } from "..";

export function useCurrentUser(): UserInterface {
  const UserService = useUserService();

  return useServiceStore(
    UserService,
    React.useCallback((state) => state.currentUser, [])
  );
}
